import React, { useEffect, createElement } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { Navbar } from './components/Navbar';
import { Footer } from './components/Footer';
import { HomePage } from './pages/HomePage';
import { AboutPage } from './pages/AboutPage';
import { CoursesPage } from './pages/CoursesPage';
import { CoachingPage } from './pages/CoachingPage';
import { AppComingSoonPage } from './pages/AppComingSoonPage';
import { TravelPage } from './pages/TravelPage';
import { FreeResourcesPage } from './pages/FreeResourcesPage';
import { WorkoutPlansPage } from './pages/WorkoutPlansPage';
import { ChecklistsPage } from './pages/ChecklistsPage';
import { CleaningListsPage } from './pages/checklists/CleaningListsPage';
import { TravelListsPage } from './pages/checklists/TravelListsPage';
import { OrganizationListsPage } from './pages/checklists/OrganizationListsPage';
import { SelfCareListsPage } from './pages/checklists/SelfCareListsPage';
import { LifeHacksListsPage } from './pages/checklists/LifeHacksListsPage';
import { SundayResetPage } from './pages/checklists/interactive/SundayResetPage';
import { CleaningTasksForgottenPage } from './pages/checklists/interactive/CleaningTasksForgottenPage';
import { HotMessCleanPage } from './pages/checklists/interactive/HotMessCleanPage';
import { UltimateCleaningSchedulePage } from './pages/checklists/interactive/UltimateCleaningSchedulePage';
import { DailyCleaningPage } from './pages/checklists/interactive/free/DailyCleaningPage';
import { WeeklyCleaningPage } from './pages/checklists/interactive/free/WeeklyCleaningPage';
import { MonthlyCleaningPage } from './pages/checklists/interactive/free/MonthlyCleaningPage';
import { QuarterlyCleaningPage } from './pages/checklists/interactive/free/QuarterlyCleaningPage';
import { BiannualCleaningPage } from './pages/checklists/interactive/free/BiannualCleaningPage';
import { YearlyCleaningPage } from './pages/checklists/interactive/free/YearlyCleaningPage';
import { DailySelfCarePage } from './pages/checklists/interactive/free/DailySelfCarePage';
import { KitchenCleaningPage } from './pages/checklists/interactive/KitchenCleaningPage';
import { LivingRoomCleaningPage } from './pages/checklists/interactive/LivingRoomCleaningPage';
import { HalfBathroomCleaningPage } from './pages/checklists/interactive/HalfBathroomCleaningPage';
import { FullBathroomCleaningPage } from './pages/checklists/interactive/FullBathroomCleaningPage';
import { TropicalCruisePackingPage } from './pages/checklists/interactive/TropicalCruisePackingPage';
import { ColdClimateCruisePackingPage } from './pages/checklists/interactive/ColdClimateCruisePackingPage';
import { PreTripHomePrepPage } from './pages/checklists/interactive/free/PreTripHomePrepPage';
import { AdminLinksPage } from './pages/AdminLinksPage';
import { ScrollToTop } from './components/ScrollToTop';
import { BoardGamePage } from './pages/games/BoardGamePage';
import { AppsHubPage } from './pages/apps/AppsHubPage';
import { TrippinThroughLifePage } from './pages/apps/TrippinThroughLifePage';
import { InnerIntentionsPage } from './pages/apps/InnerIntentionsPage';
import { TtlBoardGamePage } from './pages/apps/TtlBoardGamePage';
import { TrippinThroughLifePrivacyPage } from './pages/apps/TrippinThroughLifePrivacyPage';
import { InnerIntentionsPrivacyPage } from './pages/apps/InnerIntentionsPrivacyPage';
import { PrivacyPolicyPage } from './pages/PrivacyPolicyPage';
import { TermsPage } from './pages/TermsPage';
import { WebAppDesignPage } from './pages/services/WebAppDesignPage';
import { AnnouncementBar } from './components/AnnouncementBar';
function AppLayout() {
  const location = useLocation();
  const isGamePage = location.pathname.startsWith('/games/');
  return <div className="flex flex-col min-h-screen" data-id="element-0">
      {!isGamePage && <AnnouncementBar data-id="element-1" />}
      {!isGamePage && <Navbar data-id="element-2" />}
      <main className="flex-grow" style={{
      paddingTop: 'var(--announcement-height, 0px)'
    }} data-id="element-3">
        <Routes data-id="element-4">
          <Route path="/" element={<HomePage data-id="element-6" />} data-id="element-5" />
          <Route path="/about" element={<AboutPage data-id="element-8" />} data-id="element-7" />
          <Route path="/courses" element={<CoursesPage data-id="element-10" />} data-id="element-9" />
          <Route path="/coaching" element={<CoachingPage data-id="element-12" />} data-id="element-11" />
          <Route path="/travel" element={<TravelPage data-id="element-14" />} data-id="element-13" />
          <Route path="/free-resources" element={<FreeResourcesPage data-id="element-16" />} data-id="element-15" />
          <Route path="/free-resources/cleaning-schedule" element={<UltimateCleaningSchedulePage data-id="element-18" />} data-id="element-17" />
          <Route path="/free-resources/cleaning/daily" element={<DailyCleaningPage data-id="element-20" />} data-id="element-19" />
          <Route path="/free-resources/cleaning/weekly" element={<WeeklyCleaningPage data-id="element-22" />} data-id="element-21" />
          <Route path="/free-resources/cleaning/monthly" element={<MonthlyCleaningPage data-id="element-24" />} data-id="element-23" />
          <Route path="/free-resources/cleaning/quarterly" element={<QuarterlyCleaningPage data-id="element-26" />} data-id="element-25" />
          <Route path="/free-resources/cleaning/biannual" element={<BiannualCleaningPage data-id="element-28" />} data-id="element-27" />
          <Route path="/free-resources/cleaning/yearly" element={<YearlyCleaningPage data-id="element-30" />} data-id="element-29" />
          <Route path="/free-resources/self-care/daily" element={<DailySelfCarePage data-id="element-32" />} data-id="element-31" />
          <Route path="/checklists/cleaning/ukc-742" element={<KitchenCleaningPage data-id="element-34" />} data-id="element-33" />
          <Route path="/checklists/cleaning/ulrc-519" element={<LivingRoomCleaningPage data-id="element-36" />} data-id="element-35" />
          <Route path="/checklists/cleaning/uhbc-318" element={<HalfBathroomCleaningPage data-id="element-38" />} data-id="element-37" />
          <Route path="/checklists/cleaning/ufbc-273" element={<FullBathroomCleaningPage data-id="element-40" />} data-id="element-39" />
          <Route path="/checklists/travel/tcpl-627" element={<TropicalCruisePackingPage data-id="element-42" />} data-id="element-41" />
          <Route path="/checklists/travel/ccpl-451" element={<ColdClimateCruisePackingPage data-id="element-44" />} data-id="element-43" />
          <Route path="/free-resources/travel/home-prep" element={<PreTripHomePrepPage data-id="element-46" />} data-id="element-45" />
          <Route path="/workouts" element={<WorkoutPlansPage data-id="element-48" />} data-id="element-47" />
          <Route path="/checklists" element={<ChecklistsPage data-id="element-50" />} data-id="element-49" />
          <Route path="/checklists/cleaning" element={<CleaningListsPage data-id="element-52" />} data-id="element-51" />
          <Route path="/checklists/cleaning/sr-847" element={<SundayResetPage data-id="element-54" />} data-id="element-53" />
          <Route path="/checklists/cleaning/ctf-392" element={<CleaningTasksForgottenPage data-id="element-56" />} data-id="element-55" />
          <Route path="/checklists/cleaning/hme-561" element={<HotMessCleanPage data-id="element-58" />} data-id="element-57" />
          <Route path="/checklists/travel" element={<TravelListsPage data-id="element-60" />} data-id="element-59" />
          <Route path="/checklists/organization" element={<OrganizationListsPage data-id="element-62" />} data-id="element-61" />
          <Route path="/checklists/self-care" element={<SelfCareListsPage data-id="element-64" />} data-id="element-63" />
          <Route path="/checklists/hacks" element={<LifeHacksListsPage data-id="element-66" />} data-id="element-65" />

          <Route path="/apps" element={<AppsHubPage data-id="element-68" />} data-id="element-67" />
          <Route path="/app" element={<AppsHubPage data-id="element-70" />} data-id="element-69" />
          <Route path="/apps/trippin-through-life" element={<TrippinThroughLifePage data-id="element-72" />} data-id="element-71" />
          <Route path="/apps/trippin-through-life/privacy" element={<TrippinThroughLifePrivacyPage data-id="element-74" />} data-id="element-73" />
          <Route path="/apps/inner-intentions" element={<InnerIntentionsPage data-id="element-76" />} data-id="element-75" />
          <Route path="/apps/inner-intentions/privacy" element={<InnerIntentionsPrivacyPage data-id="element-78" />} data-id="element-77" />
          <Route path="/apps/ttl-board-game" element={<TtlBoardGamePage data-id="element-80" />} data-id="element-79" />

          <Route path="/privacy" element={<PrivacyPolicyPage data-id="element-82" />} data-id="element-81" />
          <Route path="/terms" element={<TermsPage data-id="element-84" />} data-id="element-83" />
          <Route path="/services/web-app-design" element={<WebAppDesignPage data-id="element-86" />} data-id="element-85" />

          <Route path="/twm-admin-links" element={<AdminLinksPage data-id="element-88" />} data-id="element-87" />

          {/* GHOST LINKS - GAMES */}
          <Route path="/games/ttl-483" element={<BoardGamePage data-id="element-90" />} data-id="element-89" />
        </Routes>
      </main>
      {!isGamePage && <Footer data-id="element-91" />}
    </div>;
}
export function App() {
  // Inject the Google Search Console verification meta tag into <head> (once).
  // Invisible on the page — only read by Google's crawler.
  useEffect(() => {
    const META_NAME = 'google-site-verification';
    const META_CONTENT = 'bAGx5GtZYS90ge_5rqm8nMv9ej7NwZ6te4SdULa1V14';
    if (!document.querySelector(`meta[name="${META_NAME}"]`)) {
      const meta = document.createElement('meta');
      meta.name = META_NAME;
      meta.content = META_CONTENT;
      document.head.appendChild(meta);
    }
  }, []);
  // Load MailerLite Universal script globally (once)
  useEffect(() => {
    if (!(window as any).ml) {
      ;
      (window as any).ml = function () {
        ;
        ((window as any).ml.q = (window as any).ml.q || []).push(arguments);
      };
    }
    ;
    (window as any).ml('account', '2211088');
    if (!document.querySelector('script[src="https://assets.mailerlite.com/js/universal.js"]')) {
      const script = document.createElement('script');
      script.src = 'https://assets.mailerlite.com/js/universal.js';
      script.async = true;
      document.head.appendChild(script);
    }
  }, []);
  return <BrowserRouter data-id="element-92">
      <ScrollToTop data-id="element-93" />
      <AppLayout data-id="element-94" />
    </BrowserRouter>;
}